import $ from 'jQuery';
import machine_app_state from '../models/machine_app_state';
import machineAppsCss from '../machineapps.css';
import { machineAppView }from './machine_app_view';
import { machineAppsPageLoader } from '../components/machineapps_page_loader';
import { getPendantLandingPage } from './machine_app_pendant_landing_page_view';

export function machineAppManagerView(pLeftPane, pRightPane, pMachineLogicLibrary, pSelectedAppType, pSelectedViewType, pBack) {
  // Note (mkosarek) This makes it so that going back and forth between window states works properly
  // https://stackoverflow.com/questions/19335372/back-button-backspace-does-not-work-with-window-history-pushstate
  $(window).bind("popstate", function() {
    window.location = location.href;
  });

  function render(pMachineAppType, pMachineAppView) {
    pLeftPane.empty().hide();
    pRightPane.show();

    machine_app_state.getInterface().updateMachineAppView(pMachineAppType, pMachineAppView);

    if(pMachineAppType) {
      pLeftPane.show();
      machineAppView(
        pLeftPane,
        pRightPane,
        pMachineAppType,
        pMachineLogicLibrary,
        () => pBack ? pBack() : undefined, //HACK for PATH-FOLLOWING-VENTION-IO. replace render() with undefined
        pMachineAppView
      );

    }
    else {
      const machineAppLandingPage = getPendantLandingPage(render);
      $(pRightPane.get(0)).empty().append(machineAppLandingPage);
    }
  }

  pLeftPane.hide();
  pRightPane.empty().append($('<div>').addClass('machineapps_loading_page').append(
    $('<label>').text('Loading MachineApps...'),
    machineAppsPageLoader(10, 100)
  ));

  machine_app_state.waitForInitialized(function() {
    render(pSelectedAppType, pSelectedViewType);
  });
}

